import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useState} from "../_snowpack/pkg/react.js";
import AppAuth from "../components/app-auth.js";
import {colors, fontFamily, shadow} from "../components/theme.js";
import Stack from "../components/stack.js";
import {innerHTML, withAttrs} from "../common/utils.js";
import {Title} from "../components/typo.js";
import {t} from "../common/i18n.js";
import Field from "../components/field.js";
import Logo from "../components/logo.js";
import Button from "../components/button.js";
import Form from "../components/form.js";
import {useCheckValidity} from "../common/hooks.js";
import Inline from "../components/inline.js";
import {getUrl, localizeLink} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
export default function Register(props) {
  const {error, data: initialData} = props;
  const {ref: formRef, validity: formValidity} = useCheckValidity();
  const loginLink = getUrl(Routes.login);
  const errors = error ? error.errors : {};
  const termsUrl = localizeLink("/agb");
  const privacyUrl = localizeLink("/datenschutz");
  const linkTerms = t(`<a href="{{- url}}" target="_blank">AGBs</a>`, {
    url: termsUrl
  });
  const linkPrivacy = t(`<a href="{{- url}}" target="_blank">Datenschutz</a>`, {
    url: privacyUrl
  });
  const [data, setData] = useState({...initialData, checkterms: false});
  const onFormChange = (newData) => {
    setData({...data, ...newData});
  };
  return /* @__PURE__ */ React.createElement(AppAuth, {
    ...props
  }, /* @__PURE__ */ React.createElement(LogoS, null), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Inner, null, /* @__PURE__ */ React.createElement(Headline, null, t("Erstelle ein neues Konto")), /* @__PURE__ */ React.createElement(Form, {
    ref: formRef,
    error,
    onChange: onFormChange,
    showRequiredInfo: true,
    action: "/register"
  }, /* @__PURE__ */ React.createElement(Field, {
    name: "email",
    label: t("E-Mail"),
    type: "email",
    placeholder: t("Deine E-Mail eingeben"),
    required: true,
    errors,
    data
  }), /* @__PURE__ */ React.createElement(Field, {
    name: "password",
    label: t("Passwort"),
    type: "password",
    minLength: 10,
    info: t("Mind. 10 Zeichen lang"),
    placeholder: t("Passwort eingeben"),
    required: true,
    errors,
    data
  }), /* @__PURE__ */ React.createElement(Field, {
    name: "repassword",
    label: t("Passwort wiederholen"),
    type: "password",
    placeholder: t("Passwort eingeben"),
    required: true,
    errors,
    data
  }), /* @__PURE__ */ React.createElement(Field, {
    name: "checkterms",
    label: innerHTML(t("Hiermit bestätige ich, dass ich die {{- linkTerms}} und {{- linkPrivacy}} gelesen und verstanden habe und stimme zu.", {linkTerms, linkPrivacy})),
    type: "checkbox",
    required: true,
    errors,
    data
  }), /* @__PURE__ */ React.createElement(SubmitButton, {
    type: "submit",
    disabled: !formValidity
  }, t("Konto einrichten")), /* @__PURE__ */ React.createElement(Text, null, t("Schon ein Konto?"), /* @__PURE__ */ React.createElement(Link, {
    href: loginLink
  }, t("Jetzt anmelden")))))));
}
const Container = styled.div`
  box-shadow: ${shadow.card};
  padding: 26px 31px;
`;
const Inner = styled(withAttrs(Stack, {spacing: "ml"}))``;
const Headline = styled(withAttrs(Title, {level: 1}))`
  font-size: 24px;
`;
const LogoS = styled(Logo)`
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
`;
const SubmitButton = styled(withAttrs(Button, {stretch: true}))``;
const Link = styled.a`
  color: ${colors.c};
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: 22px;
  text-decoration: underline;
`;
const Text = styled(Inline)`
  --spacing: 6px;
  display: inline-flex;
  color: ${colors.b};
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: 22px;
  text-decoration: none;
`;
const TermsText = styled.p``;
